import { SCREENING_CONST } from '@/const';
import { geolocationCalcDistFromUserLocation } from '@/helpers';
import 'dayjs/locale/fr';

export default class SearchCenter {
  constructor({
    nodeId,
    title,
    address,
    postal_code: postalCode,
    entity_type: entityType,
    city,
    cityUid,
    test_type: testType,
    labelNames,
    phone,
    website,
    location,
    reception_modality_vaccination: receptionModalityVaccination,
    reception_modality: receptionModality,
    reception_modality_displayed: receptionModalityDisplayed,
    phone_number: secondPhone,
    profession,
    type_of_place: type,
    online_and_five_eleven_center_type: fiveElevenCenter,
    center_without_rdv: noAppointementCenter,
    internal_id: internaId,
    nextAppointment,
    lon,
    lat,
    establishment_type: establishmentType,
    establishmentLabel,
    establishmentId,
    precisionTypeEg,
    labelsVaccinationDisplayed,
  }) {
    this.nodeId = nodeId;
    this.name = title;
    this.address = address;
    this.postalCode = postalCode;
    this.city = city;
    this.cityUid = cityUid;
    this.testType = testType;
    this.labelNames = labelNames;
    this.phone = phone;
    this.secondPhone = secondPhone;
    this.website = website;
    this.location = location;
    this.receptionModalityVaccination = receptionModalityVaccination;
    this.receptionModality = receptionModality;
    this.receptionModalityDisplayed = receptionModalityDisplayed;
    this.profession = profession;
    this.type = type;
    this.fiveElevenCenter = fiveElevenCenter;
    this.entityType = entityType;
    this.noAppointementCenter = noAppointementCenter;
    this.internaId = internaId;
    this.nextAppointment = nextAppointment;
    this.lon = lon;
    this.lat = lat;
    this.establishmentType = establishmentType;
    this.establishmentLabel = establishmentLabel;
    this.establishmentId = establishmentId;
    this.precisionTypeEg = precisionTypeEg;
    this.labelsVaccinationDisplayed = labelsVaccinationDisplayed;
    this.show = true;
  }

  getNodeId() {
    return this.nodeId;
  }

  getName() {
    return (typeof this.name === 'object') ? this.name[0] : this.name;
  }

  getAddress() {
    return this.address;
  }

  getPostalCode() {
    return this.postalCode;
  }

  getCity() {
    return (typeof this.city === 'object') ? this.city[0] : this.city;
  }

  getCityUid() {
    return this.cityUid;
  }

  getPrecisionTypeEg() {
    return this.precisionTypeEg;
  }

  getlabelsVaccinationDisplayed(type) {
    let labels = [];
    if (type === 'all') {
      labels = this.labelsVaccinationDisplayed;
    }
    if (type === 'vaccinGrippe') {
      labels = this.labelsVaccinationDisplayed.vaccinGrippe;
    }
    if (type === 'vaccin511') {
      labels = this.labelsVaccinationDisplayed.vaccin511;
    }
    if (type === 'vaccinNovavax') {
      labels = this.labelsVaccinationDisplayed.vaccinNovavax;
    }
    return labels;
  }

  getTestTypes() {
    if (typeof this.testType === 'string' || this.testType instanceof String) {
      return this.testType?.trim().split(', ')
        ?.filter((val) => SCREENING_CONST.CENTERS_FILTERS
          ?.find((ele) => val === ele.label));
    }
    if (typeof this.testType === 'object' || this.testType instanceof Array) {
      return this.testType
        ?.filter((val) => SCREENING_CONST.CENTERS_FILTERS
          ?.find((ele) => val === ele.label));
    }

    return [];
  }

  getPhones() {
    return this.phone;
  }

  getLocation() {
    return this.location;
  }

  getReceptionModality() {
    return this.receptionModalityDisplayed;
  }

  getType() {
    if (!this.type) return '';
    return this.type;
  }

  getEstablishmentType() {
    return this.establishmentType;
  }

  getEstablishmentLabel() {
    return this.establishmentLabel;
  }

  getEstablishmentId() {
    return this.establishmentId;
  }

  getProfession() {
    return (typeof this.profession === 'object') ? this.profession[0] : this.profession;
  }

  getWebSite() {
    return this.website;
  }

  hasFiveElevenCenter() {
    return !!this.fiveElevenCenter;
  }

  getEntityType() {
    return this.entityType;
  }

  hasNoAppointementOption() {
    return this.noAppointementCenter && this.noAppointementCenter !== 'Désactivé';
  }

  getPosLat() {
    return this.lat;
  }

  getPosLon() {
    return this.lon;
  }

  getDistance({ lat, lon } = {}) {
    const cacheId = `${lat}${lon}/${this.getPosLat()},${this.getPosLon()}`;
    if (!window.distanceCache) window.distanceCache = {};
    if (window.distanceCache[cacheId]) return window.distanceCache[cacheId];
    if (!lat || !lon || !this.lat || !this.lon) return null;
    const distance = geolocationCalcDistFromUserLocation({ lon: this.getPosLon(), lat: this.getPosLat() }, { lat, lon });
    window.distanceCache[cacheId] = Number.isFinite(distance) ? distance.toFixed(2) : null;
    return window.distanceCache[cacheId];
  }
}
